import { notFound } from 'next/navigation';

import { getChannel, getContent } from '@lib/server';
import { Offer } from '@types';

export async function getBrandOfferPageData(domain: string, offerSlug: string) {
  const channel = await getChannel(domain);

  if (!channel?.channelId) notFound();

  const offerData = await getContent<Offer>('promotionsAndOffers')
    .setDepth(0)
    .setTags([channel.channelId])
    .setWhere([
      ['fields.details.slug', 'eq', offerSlug],
      [
        'fields.brandOffers',
        'contains',
        {
          linkType: 'Entry',
          id: channel.micrositeData[0].id,
          type: 'Link',
        },
      ],
    ])
    .fetch([
      'fields.name',
      'fields.offerHeroBanner',
      'fields.landingPageContent',
      'fields.replaceAutomaticPageContent',
      'fields.seo',
      'fields.details',
      'fields.apps',
      'fields.bookingButtonText',
    ]);

  if (!offerData?.[0]) notFound();

  const { offerHeroBanner, landingPageContent, ...offer } = offerData[0]?.fields;

  const seo = {
    title: offer.seo?.title ? { absolute: offer.seo?.title } : offerHeroBanner?.slides?.[0]?.heading || offer.name,
    description: offer.seo?.description || offer.details.shortDescription,
    media: offer.seo?.media || offerHeroBanner?.slides?.[0]?.image?.desktop,
    alt: offer.seo?.title || offerHeroBanner?.slides?.[0]?.heading,
    hideEntry: offer.seo?.hideEntry,
  };

  return {
    heroBanner: offerHeroBanner,
    transitionName: channel.themeConfig?.animations,
    seo,
    page: landingPageContent,
    offer,
    apps: offer.apps,
  };
}
